import { useFeatureFlag } from '@moda/portal-stanchions';
import React from 'react';
import {
  FINAL_SALE_COPY,
  FINAL_SALE_SHORT_COPY,
  FINAL_SALE_SHORT_COPY_PLURAL
} from '../../constants';
import { ShortReturnPolicyCopyApproach } from './ShortReturnPolicyCopy';

interface Props {
  approach?: ShortReturnPolicyCopyApproach;
}

export const ReturnPolicyFinalSaleCopy: React.FC<Props> = ({
  approach = ShortReturnPolicyCopyApproach.Plural
}) => {
  const updatedReturnPolicyText = useFeatureFlag('updated-return-policy-text', [
    { default: false },
    { if: true, then: true }
  ]);

  if (updatedReturnPolicyText) {
    if (approach === ShortReturnPolicyCopyApproach.Singular) {
      return <>{FINAL_SALE_SHORT_COPY}</>;
    }

    if (approach === ShortReturnPolicyCopyApproach.Plural) {
      return <>{FINAL_SALE_SHORT_COPY_PLURAL}</>;
    }
  }

  return <>{FINAL_SALE_COPY}</>;
};
